import { Injectable, inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { InputPanel, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import { CamColorSetsService } from '../color-set.service';
import { ColorSet, ColorSetCreationPayloadInput, ColorSetModifierPayloadInput } from '../dto/color-set';

enum EColorSetFormFields {
  textColor = 'textColor',
  backgroundColor = 'backgroundColor',
  borderColor = 'borderColor',
}

@Injectable({
  providedIn: 'root',
})
export class CamColorSetFormService {
  private _colorSetsService = inject(CamColorSetsService);

  constructor() {
    this._colorSetsService.fetchColorSets$().subscribe();
  }

  public getColorSetForm(colorSet: ColorSet | null) {
    return [
      new InputPanel({
        key: 'panel',
        label: 'colorSets.form.title',
        contentClass: 'highlight-title g-space-md',
        children: [
          new InputTextBox({
            key: EColorSetFormFields.textColor,
            value: colorSet?.textColor,
            label: 'colorSets.form.textColor',
            validators: [Validators.required],
          }),
          new InputTextBox({
            key: EColorSetFormFields.backgroundColor,
            value: colorSet?.backgroundColor,
            label: 'colorSets.form.backgroundColor',
            validators: [Validators.required],
          }),
          new InputTextBox({
            key: EColorSetFormFields.borderColor,
            value: colorSet?.borderColor,
            label: 'colorSets.form.borderColor',
            validators: [Validators.required],
          }),
        ],
      }),
    ];
  }

  public colorSetCreateFormatForm(data: any): ColorSetCreationPayloadInput {
    return {
      backgroundColor: data[EColorSetFormFields.backgroundColor] ?? null,
      borderColor: data[EColorSetFormFields.borderColor] ?? null,
      textColor: data[EColorSetFormFields.textColor] ?? null,
    };
  }
  public colorSetUpdateFormatForm(data: any, colorSet: ColorSet): Partial<ColorSetModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, colorSet);
    return {
      ...this.colorSetCreateFormatForm(data),
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
